import { useMemo } from "react";

import { useReportsViewReportLayoutContext } from "@/app/app/_/views/ReportsView/ReportsViewReportLayoutContext";
import { getReportSubnavFilters } from "@/app/app/_/views/ReportsView/ReportsView.utils";
import { useReportsViewReportSubnavFilterSetup } from "@/app/app/_/views/ReportsView/ReportsView.hooks";
import { useLayoutReportFilterDefinitions } from "@/app/app/_/views/ReportsView/reportFilterDefinitions.hooks";
import { getSharedReportFilterDefinitions } from "@/app/share/report/sharedFilterDefinitions";
import { BoxForEntity } from "@/components/atoms/BoxForEntity";
import { UtilityBar } from "@/components/organisms/UtilityBar";
import { useDevice } from "@/hooks/useDevice";
import { State } from "@/state";

export function ReportsViewFiltersSubnav() {
  const { activeLayout } = useReportsViewReportLayoutContext();
  const { isNarrow } = useDevice();
  const entities = useMemo(() => activeLayout?.entities ?? [], [activeLayout]);
  const entityIdentifiers = useMemo(
    () => entities.map((entity) => entity.identifier),
    [entities],
  );

  const layoutFilterDefinitions = useLayoutReportFilterDefinitions();

  const filterDefinitions = useMemo(
    () =>
      getSharedReportFilterDefinitions(
        entities.map(({ identifier, name }) => ({ identifier, name })),
        layoutFilterDefinitions,
      ),
    [entities, layoutFilterDefinitions],
  );

  useReportsViewReportSubnavFilterSetup(
    activeLayout?.identifier,
    entityIdentifiers,
  );

  const filters = State((state) => state.filters);
  const resolvedFilters = useMemo(
    () => getReportSubnavFilters(filters, entityIdentifiers),
    [filters, entityIdentifiers],
  );

  return (
    <div className="flex items-center justify-start flex-1 min-w-0 min-h-0 h-full w-full overflow-y-hidden gap-2">
      {/* The business the report belongs to, ahead of what it is filtered by
          - on a desktop. A phone's report, or a narrow window's, has its box
          beside its title, in the bar above, and says it once. */}
      {!isNarrow && activeLayout?.entity?.identifier && (
        <BoxForEntity
          identifier={activeLayout.entity.identifier}
          representation="character"
        />
      )}
      <UtilityBar
        includeSort={false}
        disablePadding
        filters={resolvedFilters}
        filterDefinitions={filterDefinitions}
        onFiltersChange={(next) => State.setState({ filters: next })}
      />
    </div>
  );
}
